import { render, staticRenderFns } from "./vip-order.vue?vue&type=template&id=78f53e22&scoped=true&"
import script from "./vip-order.vue?vue&type=script&lang=js&"
export * from "./vip-order.vue?vue&type=script&lang=js&"
import style0 from "./vip-order.vue?vue&type=style&index=0&id=78f53e22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f53e22",
  null
  
)

export default component.exports